import { createAvatar } from '@dicebear/core';
import { funEmoji } from '@dicebear/collection';

export function generateRandomName() {
  const nouns = [
    "Neon", "Silent", "Ghostly", "Turbo", "Infinite", "Crimson", "Phantom", "Electric", "Quantum", "Radiant",
    "Glitchy", "Shiny", "Hidden", "Frozen", "Vivid", "Shadow", "Velvet", "Chrome", "Virtual", "Floating"
  ];
  const adjectives = [
    "Pixel", "Architect", "Streamer", "Prism", "Sprite", "Phantom", "Composer", "Painter", "Shader",
    "Operator", "Lancer", "Visionary", "Cycler", "Mirage", "Voxel", "Sculptor", "Animator", "Seeker", "Renderer", "Engineer"
  ];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomId = Math.floor(1000 + Math.random() * 9000);
  return `${randomNoun} ${randomAdjective}#${randomId}`;
}

export function createUserAvatar(seed) {
  return createAvatar(funEmoji, {
    seed,
    size: 32,
  }).toString();
}

// A locally-generated avatar as a data: URI, safe to drop straight into an
// <img src>. Always derive the avatar this way from a stable seed (the
// participant identity) — never render an avatar string received from a remote
// peer as HTML, or a peer can smuggle a <svg onload=...> XSS through it.
export function createUserAvatarDataUri(seed) {
  try {
    return createAvatar(funEmoji, {
      seed: seed ?? '',
      size: 32,
    }).toDataUri();
  } catch (_) {
    return '';
  }
}
